import { TReduxActions } from '../../../types/redux';
import { FILTERS_SET_BS_CENTERS_TYPE } from '../../../constants/action_types';
import { JsonQuery } from '../../../utils/jsonQuery';
import { defaultState } from './defaultState';
import { IJsonQuery } from '../../../../packages/api-models/common/json_query';

export function setBSCentersReducer(jsonQuery: IJsonQuery = defaultState, action: TReduxActions): IJsonQuery {
  switch (action.type) {
    case FILTERS_SET_BS_CENTERS_TYPE:
      return new JsonQuery(jsonQuery)
        .clearGeo()
        .setVillage(undefined)
        .setBSCenters(action.bsCenterIds)
        .getSerializable();
  }

  return jsonQuery;
}
